import React, { useEffect } from "react";
import Card from "./employees";
import AttendanceDashboardWrapper from "../components/AttendanceWrapper";
import { useDispatch } from "react-redux";

const Index = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: "SIDEBAR", num: "2" });
  }, []);

  return (
    <AttendanceDashboardWrapper>
      <Card />
    </AttendanceDashboardWrapper>
  );
};

export default Index;
